// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/flickity.pkgd.js"; import "./autoload/mixitup-multifilter.min.js"; import "./autoload/mixitup-pagination.min.js"; import "./autoload/mixitup.min.js"; import "./autoload/modal.js"; import "./autoload/xpandy-polyfill.min.js";

import "../../modules/Calltoaction/assets/scripts/main.js"; import "../../modules/Casestudies/assets/scripts/main.js"; import "../../modules/Companies/assets/scripts/main.js"; import "../../modules/Contact/assets/scripts/main.js"; import "../../modules/Contact/assets/scripts/styles.js"; import "../../modules/Hero/assets/scripts/main.js"; import "../../modules/Iconcards/assets/scripts/main.js"; import "../../modules/Logoslider/assets/scripts/main.js"; import "../../modules/Numbercards/assets/scripts/animateValues.js"; import "../../modules/Numbercards/assets/scripts/main.js"; import "../../modules/Tabs/assets/scripts/main.js"; import "../../modules/Transactions/assets/scripts/main.js";
// import "../../modules/Map/assets/scripts/main";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js